// frontend/src/pages/portfolio/components/PortfolioFooter.tsx
import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { getMicrosoftStoreUrl } from "../../../utils/storeUrl";

const colHeading =
  "font-display text-xs font-semibold uppercase tracking-wider text-slate-300";
const colLink =
  "text-sm text-slate-200 hover:text-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-primary-950 rounded";

const PortfolioFooter: React.FC = () => {
  return (
    <footer
      id="contact"
      className="border-t border-primary-800/50 bg-primary-950 py-16 text-slate-100 sm:py-20"
      aria-labelledby="contact-heading"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <h2 id="contact-heading" className="sr-only">
          Site footer and contact
        </h2>

        <div className="grid gap-10 sm:grid-cols-2 md:grid-cols-4">
          {/* Brand */}
          <div className="sm:col-span-2 md:col-span-1">
            <p className="font-display text-lg font-semibold text-white">
              Time Tracker
            </p>
            <p className="mt-1 text-xs text-slate-400">by Synquar Ai Labs</p>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-300">
              Tooling for teams that care about how time is spent, recorded,
              and reviewed.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className={colHeading}>Product</h3>
            <ul className="mt-4 space-y-3">
              <li><a href="#pricing" className={colLink}>Pricing</a></li>
              <li><a href="#how-it-works" className={colLink}>How it works</a></li>
              <li><a href="#faq" className={colLink}>FAQ</a></li>
              <li>
                <a
                  href={getMicrosoftStoreUrl()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={colLink}
                >
                  Get the app
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className={colHeading}>Resources</h3>
            <ul className="mt-4 space-y-3">
              <li><Link to="/getting-started" className={colLink}>Getting started</Link></li>
              <li><Link to="/privacy-policy" className={colLink}>Privacy policy</Link></li>
              <li><Link to="/register-org" className={colLink}>Register an organization</Link></li>
              <li><Link to="/login" className={colLink}>Log in</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className={colHeading}>Contact</h3>
            <a
              href="mailto:support@synquarailabs.com"
              className="mt-4 inline-flex items-center gap-3 text-sm font-medium text-white hover:text-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-primary-950 rounded-lg"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-900 text-slate-100 ring-1 ring-white/15">
                <Mail className="h-4 w-4" aria-hidden />
              </span>
              support@synquarailabs.com
            </a>
          </div>
        </div>

        <p className="mt-12 border-t border-white/15 pt-8 text-center text-xs text-slate-400">
          © {new Date().getFullYear()} Synquar Labs. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default PortfolioFooter;
